import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper/core';
import { useContent } from '../../services'
import Backgroundimage from '../../assets/images/background/image-7.jpg';
import quotesone from '../../assets/images/icons/quotes-1.png';

SwiperCore.use([Navigation]);

const authorImages = {
    'author-thumb-4.jpg': require('../../assets/images/resource/author-thumb-4.jpg'),
    'author-thumb-5.jpg': require('../../assets/images/resource/author-thumb-5.jpg'),
    'author-thumb-6.jpg': require('../../assets/images/resource/author-thumb-6.jpg'),
};

function Testimonialsabout() {
  const { data, loading } = useContent('aboutContent');

  if (loading || !data) return null;

  const { testimonials } = data;

  const show = {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };

  return (
    <section className="testimonials-two">
      <div className="image-layer" style={{ backgroundImage: `url(${Backgroundimage})` }}></div>
      <div className="auto-container">
        <div className="title-box centered">
          <div className="subtitle">
            <span>{testimonials.subtitle}</span>
          </div>
          <div className="pattern-image">
            <img src={require('../../assets/images/icons/separator.svg').default} alt="mySvgImage" />
          </div>
          <h2>{testimonials.title}</h2>
        </div>

        <div className="carousel-box">
          <Swiper className="testimonial-slider" {...show}>
            {testimonials.items.map((item) => (
              <SwiperSlide key={item.id} className="testi-block item">
                <div className="inner-box">
                  <div className="quote-icon">
                    <img src={quotesone} alt="" title="" />
                  </div>
                  <div className="rating">
                    {Array.from({ length: item.rating }, (_, i) => (
                      <span key={i} className="fa fa-star"></span>
                    ))}
                  </div>
                  <div className="text">{item.text}</div>
                  <div className="auth-info">
                    <div className="image">
                      <img src={authorImages[item.image]} alt={item.author} />
                    </div>
                    <div className="auth-title">{item.author}</div>
                    <div className="location">{item.location}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-button-prev">
              <span className="fal fa-angle-left"></span>
            </div>
            <div className="swiper-button-next">
              <span className="fal fa-angle-right"></span>
            </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonialsabout;
